var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"spotify-player"},[_c('script',{attrs:{"src":"https://sdk.scdn.co/spotify-player.js","type":"application/javascript","async":""}})])
}]

export { render, staticRenderFns }